var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.620117 21.0253H21.3992V0.246094H0.620117V21.0253ZM3.58857 18.0568H18.4308V3.2146H3.58857V18.0568Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.242 15.0884H39.2104V0.246094H30.3051V3.2146H24.3682V6.183H30.3051V9.15151H36.242V15.0884ZM33.2735 6.183H36.242V3.2146H33.2735V6.183Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1787 21.0253H62.9578V0.246094H42.1787V21.0253ZM45.1471 18.0568H59.9894V3.2146H45.1471V18.0568Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55713 15.088H9.52553H12.494H15.4624V12.1195V9.15112V6.18262H12.494H9.52553H6.55713V9.15112V12.1195V15.088Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1157 15.088H51.0841H54.0526H57.021V12.1195V9.15112V6.18262H54.0526H51.0841H48.1157V9.15112V12.1195V15.088Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3366 15.0883H30.3051V12.1198V9.15137H27.3366H24.3682V12.1198H27.3366V15.0883Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3682 21.0248H27.3366V18.0563V15.0879H24.3682V18.0563V21.0248Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2734 18.0563H36.2419V15.0879H33.2734",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3047 21.0251H33.2731V18.0566H30.3047",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2417 21.0251H39.2101V18.0566H36.2417",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3364 23.9938H30.3049V21.0254H27.3364",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58857 38.8355H6.55703H9.52543V35.867H12.4939V38.8355H15.4623V35.867V32.8986H12.4939V29.9301H9.52543V26.9617H12.4939V29.9301H15.4623V32.8986H18.4308H21.3992H24.3678H27.3362V29.9301H24.3678H21.3992H18.4308V26.9617H15.4623V23.9932H12.4939H9.52543H6.55703H3.58857H0.620117V26.9617H3.58857H6.55703V29.9301H3.58857H0.620117V32.8986V35.867H3.58857V38.8355Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4312 26.9617H21.3996H24.3681H27.3365V23.9932H24.3681H21.3996H18.4312V26.9617Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3681 44.7724H27.3365V38.8355H33.2734V35.867H36.2419V41.8039H39.2103V35.867H45.1472V41.8039H48.1157V23.9932H45.1472V26.9617H42.1788V23.9932H39.2103V26.9617H36.2419V23.9932H33.2734V29.9301H36.2419V32.8986H33.2734V29.9301H30.305V32.8986H27.3365V35.867H18.4312V38.8355H24.3681V44.7724ZM39.2103 32.8986H42.1788V29.9301H39.2103V32.8986Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.084 35.867H54.0525V32.8986V29.9301H57.0209V26.9617H54.0525V23.9932H51.084V26.9617V29.9301V32.8986V35.867Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.021 26.9617H59.9895V23.9932H57.021",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.021 35.8676H59.9895H62.9579V32.8992H59.9895V29.9307H57.021V32.8992V35.8676Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9893 44.7728H62.9577V41.8043V38.8359H59.9893V41.8043V44.7728Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.620117 62.5829H21.3992V41.8037H0.620117V62.5829ZM3.58857 59.6144H18.4308V44.7722H3.58857V59.6144Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3682 62.5829H27.3366V56.646H30.3051V53.6775H27.3366V50.7091H30.3051V53.6775H36.242V56.646H30.3051V62.5829H33.2735V59.6144H36.242V62.5829H39.2104V59.6144H45.1473V62.5829H57.0211V56.646H54.0527V53.6775H57.0211V50.7091H59.9896V47.7406H57.0211V41.8037H51.0842V47.7406H48.1158V53.6775H51.0842V56.646H48.1158V53.6775H45.1473V50.7091H42.1789V47.7406H39.2104V50.7091H36.242V47.7406H33.2735V44.7722H36.242V41.8037H30.3051V44.7722H27.3366V47.7406H24.3682V62.5829ZM39.2104 56.646H42.1789V53.6775H39.2104V56.646Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.21 44.7722H42.1785V41.8037H39.21",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.147 47.7409H48.1155V44.7725H45.147",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55713 56.6466H9.52553H12.494H15.4624V53.6781V50.7097V47.7412H12.494H9.52553H6.55713V50.7097V53.6781V56.6466Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9893 59.6149H62.9577V56.6465H59.9893",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/QRIcon.ee9af465af7526078ac60f52f221e80e.svg";
export { ForwardRef as ReactComponent };